import { requestImageUpload } from "@apis/common";
import type { UploadFile } from "antd/es/upload/interface";

type ThumbnailValue = string | UploadFile | null | undefined;

/**
 * 폼에서 받은 썸네일 값을 처리하여 이미지 URL을 반환합니다.
 * - string인 경우: 그대로 반환 (이미 업로드된 URL)
 * - UploadFile인 경우: 이미지 업로드 후 URL 반환
 * - null/undefined인 경우: 빈 문자열 반환
 */
export async function processFormThumbnail(thumbnailValue: ThumbnailValue, category = "manual"): Promise<string> {
    if (typeof thumbnailValue === "string") {
        return thumbnailValue;
    }

    if (typeof thumbnailValue === "object" && thumbnailValue?.originFileObj) {
        return requestImageUpload({ imageFile: thumbnailValue.originFileObj, category });
    }

    return "";
}
